import { FinancialGoalType, WizardState } from '../context/SetGoalProvider';
import { getExpenseStartDate } from './getExpenseStartDate';

export const wizardToBody = (wizard: Partial<WizardState>) => {
  if (wizard.isFinancialGoal && wizard.goalType === FinancialGoalType.LargePurchase) {
    return {
      endpoint: '/Consumer/PulseCheckGoalsUpdate/LargePurchaseGoal',
      payload: {
        ...wizard.purchase,
        oneTimeOptions: wizard.purchase?.isRecurringPurchase
          ? null
          : {
              ...wizard.purchase?.oneTimeOptions,
              targetYear: wizard.purchase?.oneTimeOptions?.isAtRetirement
                ? null
                : wizard.purchase?.oneTimeOptions?.targetYear,
            },
        recurringOptions: wizard.purchase?.isRecurringPurchase
          ? {
              ...wizard.purchase?.recurringOptions,
              startYear: wizard.purchase?.recurringOptions?.isAtRetirement
                ? null
                : wizard.purchase?.recurringOptions?.startYear,
            }
          : null,
        accounts: wizard.accountIds,
      },
    };
  }

  if (wizard.isFinancialGoal && wizard.goalType === FinancialGoalType.Expense) {
    return {
      endpoint: '/Consumer/PulseCheckGoalsUpdate/RecurringExpenseGoal',
      payload: {
        ...wizard.expense,
        startDate: getExpenseStartDate(wizard.expense?.startDate),
      },
    };
  }

  return {
    endpoint: '/Consumer/PulseCheckGoalsUpdate/NonFinancialGoal',
    payload: {
      targetDate: wizard.targetDate,
    },
  };
};
